import React from 'react';
import '../styles/PulsiaBadge.css';

const PulsiaBadge = () => {
  return (
    <a
      className="pulsia-badge"
      href="https://pulsia.fr"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Made by Pulsia.ai"
    >
      <img
        className="pulsia-badge-icon"
        src="/iconPulsia.png"
        alt="Pulsia.ai logo"
      />
      <span className="pulsia-badge-text">Made by Pulsia.ai</span>
    </a>
  );
};

export default PulsiaBadge;
